export const DossierType = {
  hotelOnly: 0,
  transportOnly: 1,
  cruise: 2,
  package: 3,
};
